/*
 * @Author: Huangxianlong
 * @Date: 2023-05-29 10:27:17
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2023-07-05 15:53:21
 * @FilePath: \h5\src\store\modules\sensor.js
 * @Description: 
 */
import * as api from '../../api';
import { router } from '../../router/index';

const sensor = {
  state: {
    sensorInfoPage: [],
    topSensorInfoPage: []
  },
  mutations: {
    //项目数据
    GETSENSORINFOPAGE(state, data) {
      state.sensorInfoPage = data;
    }
  },
  getters: {
    getSensorInfoPage(state) {
      return state.sensorInfoPage;
    },
    getTopSensorInfoPage(state) {
      return state.topSensorInfoPage;
    }
  },
  actions: {
    getSensorInfoPageAction({ commit }, dataloggerId) {
      api.getAllSensorinfoResource(dataloggerId, '3').then(function (response) {
        commit("GETSENSORINFOPAGE", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },
    getTopSensorInfoPageAction({ commit }, dataloggerId) {
      api.getTopSensorInfoByloggerIdResource(dataloggerId).then(function (response) {
        commit("getTopSensorInfoPage", response.body);
      }, function (response) {
        console.log("==error==", response);
      });
    },
    saveSensorAction({ dispatch, commit }, params) {
      let _this = this;
      api.addSensorResource(params).then(function (response) {
        if (params.dataloggerId) {
          dispatch('getSensorInfoPageAction', params.dataloggerId);
        }
      }, function (response) {
        console.log("==error==", response);
      });

    }
  }
};

export default sensor;



// WEBPACK FOOTER //
// ./src/store/modules/sensor.js